<script>
    import Axios from 'axios'
    import config from '../../../libs/config.js';
    import api from '../../../api'
    import { mapGetters, mapActions } from 'vuex'
    import _ from 'lodash'
    import _system from '../../../libs/system'	

    import { removeChannel } from '../mixins/removeChannel'

    import _email from '../../../libs/email';

	export default 
	{
        name: 'accountsEmail',
        mixins: [removeChannel],        
        data() 
        {
        	return {
                config: config,
                appId: '',
                pages: [],
                loader: true,
                modalTrigger: false,
                newAccount: {
                    email: '',
                    password: '',
                    imapHost: '',
                    imapPort: '993',
                    smtpHost: '',
                    smtpPort: '587',
                }
        	}
        },
        computed: 
	    {
	        ...mapGetters('session', ['isLoggedIn','getUser', 'getRole','getJwt']),
            ...mapGetters('accounts', ['accounts']),
            ...mapGetters('tags', ['tagsByName']),        
            ...mapGetters('workspaces', ['currentWorkspace']),
            ...mapGetters('workspaceusers', ['workspaceusers']),
	        ...mapGetters('networks', ['networks','networksByName'])
        },
        methods: {
            ...mapActions('accounts', ['setAccounts', 'removeChannel']),
            ...mapActions('networks', ['setNetworks']),
            addAccount(){

                let payload = {
                    body: {
                        "smtp":{
                            "url": this.newAccount.smtpHost,
                            "port": this.newAccount.smtpPort
                        },
                        "imap":{
                            "url": this.newAccount.imapHost,
                            "port": this.newAccount.imapPort
                        },
                        "username": this.newAccount.email,
                        "password": this.newAccount.password
                    },
                    query: {
                        state: encodeURIComponent(JSON.stringify({"workspaceId": this.currentWorkspace._id }))
                    }
                }

                
                //test
                /* payload.body.smtp.url = 'smtp.mail.yahoo.com'
                payload.body.smtp.port = 365
                payload.body.imap.url = 'imap.mail.yahoo.com'
                payload.body.imap.port = 993
                payload.body.username = 'eyupibisoglu@yahoo.com'
                payload.body.password = 'fdmdjepioiwsuomr' */

/*                 _email.api.email.create(payload, (err, res) => {
                    console.log(err)
                    if (err) return alert(err.data.message) */

                    //payload.body.workspaceId = this.currentWorkspace._id

                    //Axios.post(config.url + '/email/redirect?accessToken='+ this.getJwt, payload.body);

                    document.getElementById("auth").submit(); 
                    //location.reload(); 
                //})
                
            },
            reAuth(){
               document.getElementById("auth").submit(); 
            },            
            update_status(e, pageId){
                if(!e.target.checked) {
                    let payload = {
                        query: {
                            pageId: pageId
                        },
                        body: {
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.setTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });                   
                }else{
                    let payload = {
                        query: {
                            pageId: pageId,
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.deleteTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });
                }

            }              
        },
        mounted(){
            $('.ui.dropdown').dropdown({
                transition: 'scale'
              })
        },
        created(){

            console.log(this.accounts)
            //Store Fetching
            if(this.accounts && this.networks){
                this.pages = _.filter(this.accounts, (e) => { return e.platform == this.networksByName['Email']._id }); 
                this.loader = false;
            }  
        }
	}
</script>

<template>
	<span>

<div style="background: #f5f5f5; margin-bottom: 1rem;" class="ui grid">

<div v-if="modalTrigger" class="modalWrapper">
<div  @click="modalTrigger = false" class="modal"> </div>
   <div class="ui grid">
      <div style="margin-top: 1rem;" class="ten wide column centered">
            <div style="padding: 0; z-index:9999999;" class="ui basic segment right aligned">
               <a style="background: rgba(0,0,0,0.6);" @click="modalTrigger = false" class="ui black mini button">Close [ESC]</a>
            </div>
            <div style="z-index:9999999;" class="ui segment shadow">

                <div class="ui form">
                    <div class="field">
                        <label>Email & Password</label>
                        <input v-model="newAccount.email" placeholder="name@company.com" type="text">
                    </div>
                    <div class="field">
                        <input v-model="newAccount.password" placeholder="Password" type="password">
                    </div>
                    <div class="field">
                        <label>IMAP hostname</label>
                        <input v-model="newAccount.imapHost" placeholder="imap.example.com" type="text">
                    </div>
                    <div class="field">
                        <label>IMAP Port</label>
                        <input v-model="newAccount.imapPort" type="text">
                    </div>
                    <div class="field">
                        <label>SMTP hostname</label>
                        <input v-model="newAccount.smtpHost" placeholder="smtp.example.com" type="text">
                    </div>
                    <div class="field">
                        <label>SMTP Port</label>
                        <input v-model="newAccount.smtpPort" type="text">
                    </div>
                    <div class="field">
                    <a href="#" @click="addAccount()" class="ui fluid blue button">Add New Email Account</a>
                    </div>
                </div>

<form style="visibility: hidden;" id="auth" action="https://api.juphy.com/email/redirect" method="post">
    <input type="text" name="state" :value='JSON.stringify({"workspaceId": currentWorkspace._id })'>
    <input type="text" name="smtp" :value='JSON.stringify({ "url": newAccount.smtpHost, "port":newAccount.smtpPort })'>
    <input type="text" name="imap" :value='JSON.stringify({ "url": newAccount.imapHost, "port":newAccount.imapPort })'>
    <input type="text" name="username" :value="newAccount.email">
    <input type="text" name="password" :value="newAccount.password">
    <input type="text" name="accessToken" :value="getJwt">
    <input type="submit" value="Submit">
</form> 

<!--         <form v-if="getRole.name == 'Admin'" id="authEmail" class="ui fluid form center aligned action" :action=" config.url + '/email/redirect?accessToken='+ this.getJwt" method="post">

        <div class="field">
        <button  type="submit" value="Submit" class="ui fluid button" >Connect </button>
        </div>
        </form> -->

            </div>
      </div>
   </div>
</div>

        <div class="ten wide column">

        <button v-if="getRole.name == 'Admin'" @click="modalTrigger = true" class="ui button left floated"><i class="icon mail"></i> Add Email Account</button>
           

        </div>
        <div style="text-align: right;" class="six wide column">

        </div>
        </div>

        <div v-if="!loader && !pages.length" class="ui basic padded segment center aligned">
            <p style="color: #ccc;font-size: 20px;font-style: italic;">
                Don't have any active Gmail account
            </p>
        </div>

        <table v-if="!loader && pages.length" style="padding: 0rem 0.5rem;" class="ui very basic celled table fluid">
            <tbody>
            
            <tr v-for="account in pages" :key="account._id">
                <td><h4 class="ui image header">
                    <img :src="account.avatar" class="ui mini rounded image">
                    <div class="content">
                        {{account.name}}

                    </div>
                </h4></td>
<!--                               <td class="collapsing">
                    <a class="ui basic label">#tw-{{account.screenName}}</a>
                </td> -->
                <td class="collapsing" style="vertical-align: bottom;">


                    <div  v-if="account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') != -1" class="ui compact warning small message" style="width:400px;">
                        <div class="header">Permissions Expired</div>
                        <a :href="'#'" @click="reAuth()">Click here to re-authorize</a>
                    </div>

<!--                     <div v-if="getRole.name == 'Admin' && (account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') == -1) || (!account.tags)" class="ui fitted toggle checkbox check">
                        
                        <input v-if="account.tags && account.tags.indexOf(tagsByName['Passive']._id) != -1"  @click="update_status($event, account._id)" type="checkbox" :checked="false">
                        <input v-if="!account.tags || account.tags.indexOf(tagsByName['Passive']._id) == -1" @click="update_status($event, account._id)" type="checkbox" :checked="true"> 
                        <label></label>
                        
                    </div> -->
                </td>
                <td class="collapsing">
                <div style="background: transparent;" class="ui left dropdown icon button">
                    <i class="ellipsis vertical icon"></i>
                    <div class="menu">
                        <div @click="deleteChannel(account._id)" class="item">
                        Delete
                        </div>
                    </div>
                    </div>
                </td>
<!--                               <td class="collapsing">
                    <a :href="'/account/settings/'+ account.id" class="ui basic small icon button more-basic"><i class="cog icon"></i></a>
                </td> -->
            </tr>
            
            </tbody>
        </table> 
	</span>
</template>


<style scoped >
.ui.table thead th {
    border-bottom: none;
}
.ui.toggle.checkbox input:checked ~ label::before {
    background-color: #8ef2b6 !important;
}
.ui.toggle.checkbox label::before{
    height: 1.9rem;
}
.ui.toggle.checkbox label::after{
    height: 1.9rem;
    width: 1.9rem;
}
.ui.toggle.checkbox input:checked ~ label::after {
    left: 1.6rem;
    box-shadow: 1px 1px 1px #ddd;
}
.ui.toggle.checkbox input {
    height: 1.9rem;
}
.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 999999; 
   overflow: hidden;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%; 
   z-index: 999999; 
   overflow: hidden;
}

.shadow{
   box-shadow: 0px 0px 44px rgba(99, 99, 99, 0.85);
   border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/accounts/email.vue